import axios from "../axios-control";

export const todos = () => axios
    .get('/tipos-de-incidencia')
    .then(res => res.data)
    .catch(e => {
      if (e.response.status !== 401) {
        throw(e);
      }
    });